'use client';
import { Button, Typography } from 'components';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckCircleIcon, CopyLightIcon } from 'lib/svgs/Icons';
import { useTranslations } from 'next-intl';
import { FC, useState } from 'react';
import { cn } from 'utils/cn';

interface ICardKey {
  title: string;
  message?: string;
}

const CardKey: FC<ICardKey> = ({ title, message }) => {
  const t = useTranslations();
  const [copied, setCopied] = useState(false);

  const onCopy = () => {
    if (message) {
      // Check if the Clipboard API is supported
      if (navigator.clipboard) {
        navigator.clipboard.writeText(message);
      } else {
        // Fallback for browsers that don't support the Clipboard API
        const tempTextArea = document.createElement('textarea');
        tempTextArea.value = message;
        document.body.appendChild(tempTextArea);
        tempTextArea.focus();
        tempTextArea.select();
        document.execCommand('copy');
        document.body.removeChild(tempTextArea);
      }

      setCopied(true);
      setTimeout(() => {
        setCopied(false);
      }, 1000);
    }
  };
  return (
    <div className="flex flex-col items-center justify-between !rounded-sm bg-white p-6 shadow-custom">
      <div className="">
        <Typography variant="light2" className={cn('my-0 text-tertiary-100')}>
          {title}
        </Typography>
      </div>
      <div className="flex !w-[230px] justify-center gap-4">
        <Typography
          variant="medium1"
          className={cn('my-0 ', message ? 'text-tertiary-100' : 'text-tertiary-300')}
        >
          {message || '##############'}
        </Typography>
        <a data-tooltip-id="tolq-tooltip" data-tooltip-content={t('buttons.copy')}>
          <Button
            size="small"
            variant="icon"
            color="none"
            className="!m-0"
            onClick={onCopy}
            disabled={!message}
            startAdornment={
              <AnimatePresence mode="wait">
                <motion.div
                  transition={{ ease: 'linear', duration: 0.8 }}
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  exit={{ opacity: 0 }}
                >
                  {!copied ? (
                    <CopyLightIcon className="!text-secondary-link hover:!text-secondary-link" />
                  ) : (
                    <CheckCircleIcon />
                  )}
                </motion.div>
              </AnimatePresence>
            }
          />
        </a>
      </div>
    </div>
  );
};

export default CardKey;
